<template>
  <div id="app" ref="app" :class="{'hidden': isHidden}">
    <router-view v-if="isRouterAlive && !$route.meta.keepAlive" />
    <keep-alive>
        <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive> 


    <el-button v-if="$route.name != 'login' && $route.name != 'venueselect'" @click="talkToUs()" class="talk-to-us" type="peiso-primary-pink">💬 Report Error</el-button>


    <!-- comment due to selection between showing buttons or dialog to use hubspot function - Menard  -->
    <!-- <el-dialog title="" :visible.sync="isOpenTalkToUs" :modal-append-to-body="false" class="share-form" :close-on-click-modal="false" width="1250px" fullscreen center>
      <iframe :src="`https://share.hsforms.com/1Wh_nmuq1So2inZRY1ogWkg57m7p?venue_name=${venueName}`" class="w-100" height="100%" frameborder="0"></iframe>
    </el-dialog> -->
  </div>
</template>

<script>
export default {
  name: 'App',
  provide () {
    return {
      reload: this.reload,
      hidden: this.hidden,
      show2: this.show2,
    }
  },
  data () {
    return {
      isRouterAlive: true,
      isHidden: false,
      isOpenTalkToUs: false,
    }
  },
  methods: {
    reload () {
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
        this.$refs.app.scrollTop = 0
      })
    },
    hidden () {
      this.isHidden = true
    },
    show2 () {
      this.isHidden = false
    },

    talkToUs() {
      var venueName = sessionStorage.getItem('subVenueName')
      window.open(`https://share.hsforms.com/1Wh_nmuq1So2inZRY1ogWkg57m7p?venue_name=${venueName}`, '_blank')
    }
  }
}
</script>

<style lang="scss">
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  width: 100%;
  box-sizing: border-box;
  // padding: 0 30px;
  background: var(--background-color);
  // min-width: 1440px;
  min-height: 100vh;
  // min-width: 1350px;

  .talk-to-us {
    bottom: 1.2rem;
    right: 2rem;
    z-index: 99999;
    position: fixed;
    border-radius: 30px;
    font-size: 13px ;
    font-weight: normal;
  }

  .share-form {
    .el-dialog {

      overflow: hidden;
      border-radius: 10px;
      
      .el-dialog__body {
        padding: 0 !important;
      }

      .el-dialog__header {
        background: #f4f8fa;
      }
    }
  }
}
.hidden{
  height: 100vh;
  width: 100% !important;
  min-width: 100% !important;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/App.vue